<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="panel">{{"admin.title" | translate}}</h1>
  <h1>&nbsp; > {{"admin.apex.title" | translate}}</h1>
  <mat-form-field color="standart" [ngClass]="(isEnglish()) ? 'search-input-en' : 'search-input-de'">
    <mat-label>{{"admin.accounts.customerNumber" | translate}}</mat-label>
    <input matInput [(ngModel)]="customerNumberSearch" (keydown.enter)="search()"
                    (ngModelChange)="customerNumberSearch.length == 0 && search()">
  </mat-form-field>
  <app-search-button (click)="search()" style="margin-right: 20px;"></app-search-button>
</div>

<div class="order-table">
  <table mat-table [dataSource]="items" matSort (matSortChange)="sortData($event)" class="mat-elevation-z8">

    <ng-container matColumnDef="customerName">
      <th mat-header-cell *matHeaderCellDef [width]="420" mat-sort-header="customerName">
        {{"admin.accounts.customerName" | translate}}
      </th>
      <td mat-cell *matCellDef="let row">{{row.customerName}}</td>
    </ng-container>

    <ng-container matColumnDef="customerNumber">
      <th mat-header-cell *matHeaderCellDef [width]="240" mat-sort-header="customerNumber">
        {{"admin.accounts.customerNumber" | translate}}
      </th>
      <td mat-cell *matCellDef="let row">{{row.customerNumber}}</td>
    </ng-container>

    <ng-container matColumnDef="zip">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="zip">
        {{"admin.accounts.zip" | translate}}
      </th>
      <td mat-cell *matCellDef="let row">{{row.zip}}</td>
    </ng-container>

    <ng-container matColumnDef="apex">
      <th mat-header-cell *matHeaderCellDef [width]="120">{{"admin.apex.apex" | translate}}</th>
      <td mat-cell *matCellDef="let row">
        <mat-slide-toggle [checked]="row.apex" (change)="toggleApex(row)"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="beta">
      <th mat-header-cell *matHeaderCellDef [width]="100">{{"admin.apex.beta" | translate}}</th>
      <td mat-cell *matCellDef="let row">
        <mat-slide-toggle [checked]="row.beta" (change)="toggleBeta(row)"></mat-slide-toggle>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" #userPaginator="matPaginator"></mat-paginator>
</div>
